import OrderChart from "./Order/OrderChart";
import CustomerOrderChart from "./CustomerOrder/CustomerOrder";
import CustomerChart from "./Customer/CustomerChart";
import SalesExpertChart from "./SalesExpert/SalesExpertChart";
import ProductionStepChart from "./ProductionStep/ProductionStepChart";
import DesignerChart from "./Designer/DesignerChart";
import DamageChart from "./Damage/DamageChart";
import ProductionChart from "./Production/ProductionChart";
import SellingPriceChart from "./SellingPrice/SellingPriceChart";
import OrderCompareChart from "./Compare/OrderCompareChart";
import OrderTypeChart from "./OrderType/OrderTypeChart";
import ProductionPlateChart from "./ProductionPlate/ProductionPlateChart";
import { Grid } from "@mui/material";
import Layout from "./components/Layout";
import { useInView } from "@react-spring/web";
import useGetRoles from "../../../General/Hooks/useGetRoles";
import useDeviceType from "../../global/Hooks/useDeviceType";
import useDashboardContainer from "../DashboardChart/components/useDashboardContainer";
import { useState } from "react";
import DesignerTimeDesign from "./DesignerTimeDesign/DesignerTimeDesign";
import CustomerTimeDesign from "./CustomerTimeDesign/CustomerTimeDesign";

const Chart = () => {
  const [refDamage, inViewDamage] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refPlateArea, inViewPlateArea] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refCustomerOrder, inViewCustomerOrder] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refOrder, inViewOrder] = useInView({ triggerOnce: true, once: true });
  const [refKlischePrice, inViewKlischePrice] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refInvoicePrice, inViewInvoicePrice] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refHourlyChart, inViewHourlyChart] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refOrderAssignToDesigner, inViewOrderAssignToDesigner] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refOrderCompareChart, inViewOrderCompareChart] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refTimeDesigner, inViewTimeDesigner] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refCustomerDesigner, inViewCustomerDesigner] = useInView({
    triggerOnce: true,
    once: true,
  });

  const [refOrderTypeChart, inViewOrderTypeChart] = useInView({
    triggerOnce: true,
    once: true,
  });
  const [refProductionPlateChart, inViewProductionPlateChart] = useInView({
    triggerOnce: true,
    once: true,
  });
  const roles = useGetRoles();
  const hasCustomer = roles.some((role) => role.roleName === "Customer");
  const deviceType = useDeviceType();
  const { access, chartsAccess } = useDashboardContainer();
  const [activeChart, setActiveChart] = useState("all");

  const {
    CustomerOrderRegisterCountChartAccess,
    DesignerOrderRegisterCountChart,
    GetAccessAvrageKlischePrice,
    GetAccessPersonLeave,
    GetPersonDesignerChart,
    GetPlateAreaChartAccess,
    OrderCountChartAccess,
    OrderCountChartForCustomer,
    palateDamage,
    GetAccessOrderCompare,
    GetAccessOrderType,
    GetAccessProductionPlate,
    getInvoicePriceChart,
    getHourlyOrderRegisterCountChart,
    GetDesignerOrderDesignHistoryChart,
    GetCustomerOrderDesignHistoryChart,
    GetOrderCountChart,
    GetKlischeTypeRatio,
  } = access;

  return (
    <>
      {activeChart === "all" &&
        OrderCountChartForCustomer &&
        chartsAccess.includes("customerOrderChart") && (
          <Grid ref={refCustomerOrder} item xs={12}>
            {inViewCustomerOrder && (
              <Layout>
                <CustomerOrderChart />
              </Layout>
            )}
          </Grid>
        )}
      {(activeChart === "all" || activeChart === "order") &&
        OrderCountChartAccess &&
        chartsAccess.includes("orderChart") && (
          <Grid ref={refOrder} item xs={12}>
            {inViewOrder && (
              <Layout>
                <OrderChart />
              </Layout>
            )}
          </Grid>
        )}
      {/* گزارش مشتریان برتر */}
      {(activeChart === "all" || activeChart === "customer") &&
        CustomerOrderRegisterCountChartAccess &&
        chartsAccess.includes("customerChart") && <CustomerChart />}
      {/* گزارش کارشناسان فروش */}
      {(activeChart === "all" || activeChart === "saleExpert") &&
        access.getSalesExpertInvoicePriceChart &&
        chartsAccess.includes("saleExpertChart") && (
          <Grid item xs={12}>
            <Layout>
              <SalesExpertChart />
            </Layout>
          </Grid>
        )}
      {/* گزاش سفارشات - ساعت */}
      {(activeChart === "all" || activeChart === "hourly") &&
        getHourlyOrderRegisterCountChart &&
        chartsAccess.includes("orderHourChart") && (
          <Grid ref={refHourlyChart} item xs={12}>
            {inViewHourlyChart && <ProductionStepChart />}
          </Grid>
        )}
      {/* گزارش طراحان */}
      {(activeChart === "all" || activeChart === "designer") &&
        DesignerOrderRegisterCountChart &&
        chartsAccess.includes("designerChart") && (
          <Grid ref={refOrderAssignToDesigner} item xs={12}>
            {inViewOrderAssignToDesigner && (
              <Layout>
                <DesignerChart />
              </Layout>
            )}
          </Grid>
        )}
      {/* گزارش خرابی */}
      {(activeChart === "all" || activeChart === "damage") &&
        palateDamage &&
        chartsAccess.includes("damagePlateChart") && (
          <Grid ref={refDamage} item xs={12}>
            {inViewDamage && (
              <Layout>
                <DamageChart />
              </Layout>
            )}
          </Grid>
        )}
      {/* گزارش تولید */}
      <Grid container spacing={2}>
        {(activeChart === "all" || activeChart === "production") &&
          GetPlateAreaChartAccess &&
          chartsAccess.includes("productionChart") && (
            <Grid ref={refPlateArea} item xs={12}>
              {inViewPlateArea && (
                <Layout>
                  <ProductionChart />
                </Layout>
              )}
            </Grid>
          )}
        {/* گزارش فاکتورها */}
        {(activeChart === "all" || activeChart === "price") &&
          GetAccessAvrageKlischePrice &&
          chartsAccess.includes("priceChart") && (
            <Grid ref={refKlischePrice} item xs={12}>
              {inViewKlischePrice && (
                <Layout>
                  <SellingPriceChart />
                </Layout>
              )}
            </Grid>
          )}
      </Grid>
      {/* گزارش مقایسه */}
      {(activeChart === "all" || activeChart === "compare") &&
        GetAccessOrderCompare &&
        chartsAccess.includes("compareChart") && (
          <Grid ref={refOrderCompareChart} item xs={12}>
            {inViewOrderCompareChart && (
              <Layout>
                <OrderCompareChart />
              </Layout>
            )}
          </Grid>
        )}
      {activeChart === "all" &&
        GetDesignerOrderDesignHistoryChart &&
        chartsAccess.includes("designerTimeChart") && (
          <Grid ref={refTimeDesigner} item xs={12}>
            {inViewTimeDesigner && (
              <Layout>
                <DesignerTimeDesign />
              </Layout>
            )}
          </Grid>
        )}
      {activeChart === "all" &&
        GetCustomerOrderDesignHistoryChart &&
        chartsAccess.includes("customerTimeChart") && (
          <Grid ref={refCustomerDesigner} item xs={12}>
            {inViewCustomerDesigner && (
              <Layout>
                <CustomerTimeDesign />
              </Layout>
            )}
          </Grid>
        )}
    
        {activeChart === "all" &&
          GetOrderCountChart &&
          chartsAccess.includes("orderTypeChart") && (
            <Grid ref={refOrderTypeChart} item xs={12}>
              {inViewOrderTypeChart && (
                <Layout>
                  <OrderTypeChart />
                </Layout>
              )}
            </Grid>
          )}

        {activeChart === "all" &&
          GetKlischeTypeRatio &&
          chartsAccess.includes("productionPlateChart") && (
            <Grid ref={refProductionPlateChart} item xs={12}>
              {inViewProductionPlateChart && (
                <Layout>
                  <ProductionPlateChart />
                </Layout>
              )}
            </Grid>
          )}
     
    </>
  );
};

export default Chart;
